<template>
  <div class="row collapsible-body summary-page">
    <h4 class="col s12 light">Récapitulatif</h4>

    <form class="col s12" autocomplete="off">

      <!-- =====================================================
           TRAJET
           ===================================================== -->
      <section class="summary-section">
        <h5 class="section-title">Trajet</h5>

        <div class="info-card">

          <p class="info-text">
            Vous allez voyager de
            <strong>{{ departure_name }}</strong>
            à
            <strong>{{ destination_name }}</strong>
            le
            <strong>{{ date }}</strong>

            <span v-if="hour">
              à <strong>{{ hour }}</strong>
            </span>.
          </p>

          <p v-if="!datereturn" class="info-text">
            Pas de retour prévu.
          </p>

          <p
            v-if="infoVoyageur && infoVoyageur.trim()"
            class="travel-info"
          >
            {{ decodeText(infoVoyageur) }}
          </p>

          <!-- TRAJET RETOUR -->
          <div v-if="datereturn" class="return-trip">

            <p class="info-text return-info">
              Votre trajet retour est prévu le
              <strong>{{ datereturn }}</strong>

              <span v-if="hourreturn">
                à <strong>{{ hourreturn }}</strong>
              </span>.
            </p>

            <p
              v-if="
                infoVoyageurRetour &&
                infoVoyageurRetour.trim()
              "
              class="travel-info"
            >
              {{ decodeText(infoVoyageurRetour) }}
            </p>

          </div>

        </div>
      </section>


      <!-- =====================================================
           COORDONNÉES
           ===================================================== -->
      <section class="summary-section">
        <h5 class="section-title">Coordonnées</h5>

        <div class="info-card contact-card">

          <div class="contact-row">
            <span>Téléphone</span>
            <strong>{{ phone }}</strong>
          </div>

          <div class="contact-row">
            <span>Mail</span>
            <strong>{{ mail }}</strong>
          </div>

        </div>
      </section>


      <!-- =====================================================
           PASSAGERS
           ===================================================== -->
      <section class="summary-section">

        <h5 class="section-title">
          Passager{{ place > 1 ? "s" : "" }}
        </h5>

        <div
          v-for="(num, id) in place"
          :key="id"
          class="passenger-card"
        >

          <!-- EN-TÊTE PASSAGER -->
          <div class="passenger-header">

            <span class="passenger-number">
              Passager {{ id + 1 }}
            </span>

            <strong class="passenger-name">
              {{ passengers.firstname[id] }}
              {{ passengers.lastname[id] }}
            </strong>

          </div>


          <!-- =================================================
               INFORMATIONS PASSAGER
               ================================================= -->
          <div class="passenger-info">

            <div class="passenger-info-item">
              <span>Né le</span>

              <strong>
                {{ passengers.birthday[id] }}
              </strong>
            </div>


            <div class="passenger-info-item">
              <span>Nationalité</span>

              <strong>
                {{ passengers.nationality[id] }}
              </strong>
            </div>


            <div class="passenger-info-item passport-info">
              <span>Numéro de passeport</span>

              <strong>
                {{ passengers.passport[id] }}
              </strong>
            </div>

          </div>


          <!-- =================================================
               TARIFICATION
               ================================================= -->
          <div
            v-if="passengers.prices[id]"
            class="pricing-card"
          >

            <!-- TARIF PRINCIPAL -->
            <div class="main-price">

              <span class="main-price-label">
                Tarif {{ getTarifLabel(passengers.prices[id].typeTarif) }}
              </span>

              <strong class="main-price-value">
                {{ format(passengers.prices[id].amount) }}
              </strong>

            </div>


            <!-- =================================================
                 ANNULATION / MODIFICATION
                 ================================================= -->
            <div
              v-if="
                Number(
                  passengers.prices[id].fraisAnnulationApresDepart
                ) !== 0 ||
                Number(
                  passengers.prices[id].fraisAnnulationAvantDepart
                ) !== 0 ||
                Number(
                  passengers.prices[id].fraisModificationApresDepart
                ) !== 0 ||
                Number(
                  passengers.prices[id].fraisModificationAvantDepart
                ) !== 0
              "
              class="fees-group"
            >

              <div class="fees-group-title">
                Annulation et modification
              </div>

              <div class="fee-list">

                <!-- 1. MODIFICATION AVANT DÉPART -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .fraisModificationAvantDepart
                    ) !== 0
                  "
                  class="fee-row"
                >

                  <span>
                    Frais de modification avant départ
                  </span>

                  <strong>
                    {{
                      passengers.prices[id]
                        .fraisModificationAvantDepart
                    }} %
                  </strong>

                </div>


                <!-- 2. MODIFICATION APRÈS DÉPART -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .fraisModificationApresDepart
                    ) !== 0
                  "
                  class="fee-row"
                >

                  <span>
                    Frais de modification après départ
                  </span>

                  <strong>
                    {{
                      passengers.prices[id]
                        .fraisModificationApresDepart
                    }} %
                  </strong>

                </div>


                <!-- 3. ANNULATION AVANT DÉPART -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .fraisAnnulationAvantDepart
                    ) !== 0
                  "
                  class="fee-row"
                >

                  <span>
                    Frais d'annulation avant départ
                  </span>

                  <strong>
                    {{
                      passengers.prices[id]
                        .fraisAnnulationAvantDepart
                    }} %
                  </strong>

                </div>


                <!-- 4. ANNULATION APRÈS DÉPART -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .fraisAnnulationApresDepart
                    ) !== 0
                  "
                  class="fee-row"
                >

                  <span>
                    Frais d'annulation après départ
                  </span>

                  <strong>
                    {{
                      passengers.prices[id]
                        .fraisAnnulationApresDepart
                    }} %
                  </strong>

                </div>

              </div>
            </div>


            <!-- =================================================
                 BAGAGES
                 ================================================= -->
            <div
              v-if="
                Number(
                  passengers.prices[id].franchiseMainAller
                ) !== 0 ||
                Number(
                  passengers.prices[id].franchiseMainRetour
                ) !== 0 ||
                Number(
                  passengers.prices[id].franchiseSouteAller
                ) !== 0 ||
                Number(
                  passengers.prices[id].franchiseSouteRetour
                ) !== 0 ||
                (
                  passengers.prices[id].typeTarif === 'B' &&
                  datereturn
                )
              "
              class="fees-group"
            >

              <div class="fees-group-title">
                Bagages
              </div>

              <div class="fee-list">

                <!-- FRANCHISE MAIN ALLER -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .franchiseMainAller
                    ) !== 0
                  "
                  class="fee-row"
                >

                  <span>
                    Franchise main aller
                  </span>

                  <strong>
                    {{ passengers.prices[id].franchiseMainAller }} kg
                  </strong>

                </div>


                <!-- FRANCHISE MAIN RETOUR -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .franchiseMainRetour
                    ) !== 0
                  "
                  class="fee-row"
                >

                  <span>
                    Franchise main retour
                  </span>

                  <strong>
                    {{ passengers.prices[id].franchiseMainRetour }} kg
                  </strong>

                </div>


                <!-- FRANCHISE SOUTE ALLER -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .franchiseSouteAller
                    ) !== 0 ||
                    passengers.prices[id].typeTarif === 'B'
                  "
                  class="fee-row"
                >

                  <span>
                    Franchise soute aller
                  </span>

                  <strong>
                    {{ passengers.prices[id].franchiseSouteAller }} kg
                  </strong>

                </div>


                <!-- FRANCHISE SOUTE RETOUR -->
                <div
                  v-if="
                    Number(
                      passengers.prices[id]
                        .franchiseSouteRetour
                    ) !== 0 ||
                    (
                      passengers.prices[id].typeTarif === 'B' &&
                      datereturn
                    )
                  "
                  class="fee-row"
                >

                  <span>
                    Franchise soute retour
                  </span>

                  <strong>
                    {{ passengers.prices[id].franchiseSouteRetour }} kg
                  </strong>

                </div>

              </div>
            </div>

          </div>
        </div>
      </section>


      <!-- =====================================================
           TOTAL
           ===================================================== -->
      <div class="total-card">

        <span class="total-label">
          Montant total à régler
        </span>

        <strong class="total-value">
          {{ format(total) }}
        </strong>

      </div>


      <!-- =====================================================
           CGV
           ===================================================== -->
      <div class="cgu-container">

        <label for="cbcgu">

          <input
            type="checkbox"
            id="cbcgu"
            class="filled-in"
            v-model="cgu"
          />

          <span class="left-align cgu-text">
            En confirmant votre commande, vous reconnaissez avoir
            pris connaissance des
            <a
              href="/conditions-generales-de-vente-et-de-transport/"
              target="_blank"
            >
              conditions générales de vente et transport
            </a>,
            et les accepter en totalité.
          </span>

        </label>

      </div>


      <!-- =====================================================
           ACTIONS
           ===================================================== -->
      <div class="summary-actions">

        <a
          id="cancelSummary"
          class="action-retour"
        >
          corriger
        </a>

        <button
          id="validSummary"
          class="waves-effect waves-light btn"
        >
          Payer maintenant
        </button>

      </div>

    </form>
  </div>
</template>


<script>
import axios from "axios";
import API from "../api.js";
import M from "materialize-css";
import jQuery from "jquery";

window.jQuery = jQuery;

require("jquery.redirect/jquery.redirect.js");

export default {
  props: {},

  data() {
    return {
      departure: null,
      infoVoyageur: "",
      infoVoyageurRetour: "",

      destination: null,

      departure_name: null,
      destination_name: null,

      place: 1,

      date: null,
      datereturn: null,

      codedate: null,
      codedatereturn: null,

      phone: null,
      mail: null,

      hour: null,
      hourreturn: null,

      arrivalInfo: null,
      arrivalInfoReturn: null,

      passengers: {
        firstname: ["orel"],
        lastname: ["orel"],
        birthday: ["orel"],
        nationality: ["orel"],
        paysnaissance: ["orel"],
        villenaissance: ["orel"],
        passport: ["orel"],
        prices: [{ amount: 12 }],
      },

      cities: [],

      total: 0,

      cgu: true
    };
  },


  mounted() {

    this.cgu = false;


    /* =====================================================
       RÉCUPÉRATION DES VILLES
       ===================================================== */

    axios.get(API.cities).then((resp) => {
      this.cities = resp.data.cities;
    });


    /* =====================================================
       RÉCUPÉRATION DES DONNÉES DU VOYAGE
       ===================================================== */

    this.$root.$on("emit-travelers", async (data) => {

      let city;

      for (const [key, value] of Object.entries(data)) {

        switch (key) {

          case "departure":
          case "destination":

            city = this.$data.cities.find(
              (c) => c.code == value
            );

            this[key + "_name"] =
              "name" in city ? city.name : value;

            this[key] = value;

            break;

          default:

            this[key] = value;

        }
      }


      /* ===================================================
         CALCUL DU TARIF
         =================================================== */

      this.total = 0;

      this.passengers.prices = Array(this.place);


      this.passengers.birthday
        .slice(0, this.place)
        .map((val, id) => {

          axios
            .get(API.prices, {
              params: {

                destination: this.destination,

                departure: this.departure,

                date_leave: this.date
                  .split("/")
                  .reverse()
                  .join("-"),

                date_return: this.datereturn
                  ? this.datereturn
                      .split("/")
                      .reverse()
                      .join("-")
                  : "",

                birthday: val
                  .split("/")
                  .reverse()
                  .join("-"),

              },
            })

            .then((p) => {

              this.passengers.prices[id] =
                p.data.prices[0];

              this.total += p.data.prices.reduce(
                (acc, val) =>
                  acc + Number(val.amount),
                0
              );

              this.$forceUpdate();

            });

        });


      /* ===================================================
         RÉCUPÉRATION DES TRAJETS
         =================================================== */

      axios.all([

        /* TRAJET ALLER */

        axios.get(API.travels, {
          params: {

            destination: this.destination,

            departure: this.departure,

            start_date: this.date
              .split("/")
              .reverse()
              .join("-"),

            end_date: this.date
              .split("/")
              .reverse()
              .join("-"),

          },
        }),


        /* TRAJET RETOUR */

        this.datereturn

          ? axios.get(API.travels, {
              params: {

                destination: this.departure,

                departure: this.destination,

                start_date: this.datereturn
                  .split("/")
                  .reverse()
                  .join("-"),

                end_date: this.datereturn
                  .split("/")
                  .reverse()
                  .join("-"),

              },
            })

          : Promise.resolve(null)

      ])
        .then(
          axios.spread(
            (respAller, respRetour) => {

              /* ===========================================
                 TRAJET ALLER
                 =========================================== */

              const voyageAller =
                respAller.data.travels[0];


              if (voyageAller) {

                this.infoVoyageur =
                  voyageAller.infoVoyageur || "";

                this.hour =
                  voyageAller.time
                    ? voyageAller.time.substring(0, 5)
                    : null;

                this.arrivalInfo =
                  this.getArrivalInfo(
                    this.departure,
                    this.destination,
                    this.hour
                  );

              }


              /* ===========================================
                 TRAJET RETOUR
                 =========================================== */

              if (respRetour) {

                const voyageRetour =
                  respRetour.data.travels[0];


                if (voyageRetour) {

                  this.infoVoyageurRetour =
                    voyageRetour.infoVoyageur || "";

                  this.hourreturn =
                    voyageRetour.time
                      ? voyageRetour.time.substring(0, 5)
                      : null;

                  this.arrivalInfoReturn =
                    this.getArrivalInfo(
                      this.destination,
                      this.departure,
                      this.hourreturn
                    );

                }

              } else {

                this.infoVoyageurRetour = "";

                this.hourreturn = null;

                this.arrivalInfoReturn = null;

              }

            }
          )
        );

    });


    /* =====================================================
       BOUTON PAYER
       ===================================================== */

    jQuery("#validSummary").on(
      "click",
      function (e) {

        e.preventDefault();

        this.save();

      }.bind(this)
    );


    /* =====================================================
       BOUTON CORRIGER
       ===================================================== */

    jQuery("#cancelSummary").on(
      "click",
      function () {

        var instance =
          M.Collapsible.getInstance(
            jQuery(".collapsible")
          );

        instance.open(1);

        jQuery("html, body").animate(
          {
            scrollTop: 0
          },
          "slow"
        );

      }
    );

  },


  /* =======================================================
     WATCH
     ======================================================= */

  watch: {

    cgu: function (val) {

      let valideBtn =
        document.querySelector("#validSummary");


      if (val === true) {

        valideBtn.classList.remove(
          "disabled"
        );

      } else {

        valideBtn.classList.add(
          "disabled"
        );

      }

    }

  },


  /* =======================================================
     METHODS
     ======================================================= */

  methods: {

    /* =====================================================
       DÉCODAGE
       ===================================================== */

    decodeText(text) {

      return decodeURIComponent(
        escape(text)
      );

    },


    /* =====================================================
       FORMATAGE DES PRIX
       ===================================================== */

    format(num) {

      return Number(num).toFixed(2) + "€";

    },


    /* =====================================================
       TYPE DE TARIF
       ===================================================== */

    getTarifLabel(type) {

      switch (type) {

        case "A":
          return "Adulte";

        case "E":
          return "Enfant";

        case "B":
          return "Bébé";

        default:
          return type || "";

      }

    },


    /* =====================================================
       CALCUL DE L'ARRIVÉE
       ===================================================== */

    getArrivalInfo(
      departure,
      destination,
      time
    ) {

      if (!time) {
        return null;
      }

      const normalizedTime =
        String(time).substring(0, 5);


      /* MA → AN
         12:00 → vers 17:00 */

      if (
        departure === "MA" &&
        destination === "AN" &&
        normalizedTime === "12:00"
      ) {

        return "vers 17:00";

      }


      /* AN → MA
         21:00 → vers 07:00 */

      if (
        departure === "AN" &&
        destination === "MA" &&
        normalizedTime === "21:00"
      ) {

        return "vers 07:00";

      }


      /* MA → GC
         12:00 → J+1 vers 17:00 */

      if (
        departure === "MA" &&
        destination === "GC" &&
        normalizedTime === "12:00"
      ) {

        return "J+1 vers 17:00";

      }


      /* MA → GC
         20:00 → vers 07:00 */

      if (
        departure === "MA" &&
        destination === "GC" &&
        normalizedTime === "20:00"
      ) {

        return "vers 07:00";

      }


      /* GC → MA
         12:00 → J+1 vers 07:00 */

      if (
        departure === "GC" &&
        destination === "MA" &&
        normalizedTime === "12:00"
      ) {

        return "J+1 vers 07:00";

      }


      /* GC → MA
         20:00 → vers 07:00 */

      if (
        departure === "GC" &&
        destination === "MA" &&
        normalizedTime === "20:00"
      ) {

        return "vers 07:00";

      }


      /* AN → GC
         12:00 → vers 17:00 */

      if (
        departure === "AN" &&
        destination === "GC" &&
        normalizedTime === "12:00"
      ) {

        return "vers 17:00";

      }


      /* GC → AN
         12:00 → vers 17:00 */

      if (
        departure === "GC" &&
        destination === "AN" &&
        normalizedTime === "12:00"
      ) {

        return "vers 17:00";

      }


      return null;

    },


    /* =====================================================
       ENREGISTREMENT
       ===================================================== */

    save() {

      console.log(
        "saving reservation !"
      );

      console.log(
        this.$data
      );


      const siren = {

        codedate:
          this.$data.codedate,

        codedatereturn:
          this.$data.codedatereturn,

        mail:
          this.$data.mail,

        phone:
          this.$data.phone,

        passengers:
          JSON.stringify(
            this.$data.passengers
          )

      };


      console.log(siren);


      jQuery.redirect(
        API.save,
        siren,
        "POST"
      );

    },

  },

};
</script>


<style scoped>

/* =========================================================
   PAGE RÉCAPITULATIF
   ========================================================= */

.summary-page {

  background-color: #fff;

  margin-top: 105px;

  margin-bottom: 0;

  color: rgba(0, 0, 0, 0.87);

  padding-bottom: 30px;

}


/* =========================================================
   SECTIONS
   ========================================================= */

.summary-section {

  margin-bottom: 30px;

}


.section-title {

  margin: 0 0 12px 0;

  font-size: 1.25rem;

  font-weight: 400;

  color: #333;

}


/* =========================================================
   INFORMATIONS TRAJET
   ========================================================= */

.info-card {

  background: #fafafa;

  border: 1px solid #e5e5e5;

  border-radius: 6px;

  padding: 18px 20px;

}


.info-text {
  margin: 0;
  line-height: 1.6;
}


.info-text:last-child {

  margin-bottom: 0;

}


/* =========================================================
   ARRIVÉE
   ========================================================= */

.arrival-info {

  margin: 12px 0 0 0;

  padding: 10px 14px;

  background: #f3f3f3;

  border-left: 3px solid #777;

  line-height: 1.5;

}


.arrival-label {

  color: #666;

  margin-right: 5px;

}


.return-info {

  margin-top: 15px;

}


/* =========================================================
   INFORMATIONS VOYAGE
   ========================================================= */

.travel-info {

  margin: 14px 0 0 0;

  padding-top: 12px;

  border-top: 1px solid #e5e5e5;

  color: #666;

  line-height: 1.5;

}


.return-trip {

  margin-top: 5px;

  padding-top: 5px;

}


/* =========================================================
   COORDONNÉES
   ========================================================= */

.contact-row {

  display: flex;

  justify-content: space-between;

  align-items: center;

  gap: 20px;

  padding: 9px 0;

  border-bottom: 1px solid #e5e5e5;

}


.contact-row:last-child {

  border-bottom: none;

}


.contact-row span {

  color: #777;

}


.contact-row strong {

  font-weight: 500;

  text-align: right;

}


/* =========================================================
   PASSAGER
   ========================================================= */

.passenger-card {

  background: #fff;

  border: 1px solid #dedede;

  border-radius: 6px;

  overflow: hidden;

  margin-bottom: 20px;

}


.passenger-header {

  background: #f5f5f5;

  padding: 14px 18px;

  border-bottom: 1px solid #dedede;

}


.passenger-number {

  display: block;

  color: #777;

  font-size: 0.8rem;

  margin-bottom: 3px;

  text-transform: uppercase;

  letter-spacing: 0.04em;

}


.passenger-name {

  display: block;

  font-size: 1.1rem;

  font-weight: 500;

}


/* =========================================================
   INFORMATIONS PASSAGER
   ========================================================= */

.passenger-info {

  display: flex;

  flex-wrap: wrap;

  gap: 20px 40px;

  padding: 16px 18px;

  border-bottom: 1px solid #e5e5e5;

}


.passenger-info-item {

  display: flex;

  flex-direction: column;

  min-width: 120px;

}


.passenger-info-item span {

  color: #888;

  font-size: 0.78rem;

  margin-bottom: 3px;

}


.passenger-info-item strong {

  font-weight: 500;

}


.passport-info {

  min-width: 200px;

}


/* =========================================================
   TARIFICATION
   ========================================================= */

.pricing-card {

  background: #fff;

}


/* TARIF PRINCIPAL */

.main-price {

  display: flex;

  justify-content: space-between;

  align-items: center;

  padding: 20px 18px;

  background: #f8f8f8;

}


.main-price-label {

  font-size: 1.05rem;

  font-weight: 500;

}


.main-price-value {

  font-size: 1.35rem;

  font-weight: 600;

  white-space: nowrap;

}


/* =========================================================
   FRAIS
   ========================================================= */

.fees-group {

  border-top: 1px solid #e5e5e5;

}


.fees-group-title {

  padding: 15px 18px 8px 18px;

  color: #666;

  font-size: 0.82rem;

  font-weight: 600;

  text-transform: uppercase;

  letter-spacing: 0.04em;

}


.fee-list {

  padding: 0 18px 10px 18px;

}


.fee-row {

  display: flex;

  justify-content: space-between;

  align-items: center;

  gap: 20px;

  padding: 9px 0;

  border-bottom: 1px solid #eeeeee;

  font-size: 0.9rem;

}


.fee-row:last-child {

  border-bottom: none;

}


.fee-row span {

  color: #666;

  line-height: 1.4;

}


.fee-row strong {

  color: #333;

  font-weight: 500;

  white-space: nowrap;

}


/* =========================================================
   TOTAL
   ========================================================= */

.total-card {

  display: flex;

  justify-content: space-between;

  align-items: center;

  margin: 30px 0;

  padding: 20px;

  background: #fafafa;

  border-top: 2px solid #333;

  border-bottom: 2px solid #333;

}


.total-label {

  font-size: 1.1rem;

  font-weight: 500;

}


.total-value {

  font-size: 1.6rem;

  font-weight: 700;

  white-space: nowrap;

}


/* =========================================================
   CGV
   ========================================================= */

.cgu-container {

  min-height: 95px;

  padding: 10px 0;

}


.cgu-text {

  line-height: 1.5;

}


/* =========================================================
   ACTIONS
   ========================================================= */

.summary-actions {

  display: flex;

  justify-content: flex-end;

  align-items: center;

  gap: 25px;

  margin-top: 10px;

}


.action-retour {

  cursor: pointer;

  color: #555;

}


.action-retour:hover {

  text-decoration: underline;

}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 600px) {

  .summary-page {

    margin-top: 50px;

  }


  .info-card {

    padding: 15px;

  }


  .arrival-info {

    padding: 9px 11px;

  }


  .contact-row {

    display: block;

  }


  .contact-row strong {

    display: block;

    text-align: left;

    margin-top: 4px;

  }


  .passenger-info {

    display: block;

  }


  .passenger-info-item {

    margin-bottom: 12px;

  }


  .passenger-info-item:last-child {

    margin-bottom: 0;

  }


  .main-price {

    padding: 18px 15px;

  }


  .main-price-value {

    font-size: 1.2rem;

  }


  .fees-group-title {

    padding-left: 15px;

    padding-right: 15px;

  }


  .fee-list {

    padding-left: 15px;

    padding-right: 15px;

  }


  .fee-row {

    align-items: flex-start;

  }


  .fee-row span {

    flex: 1;

  }


  .total-card {

    display: block;

    text-align: center;

  }


  .total-label {

    display: block;

    margin-bottom: 8px;

  }


  .summary-actions {

    justify-content: space-between;

    gap: 15px;

  }


  .summary-actions #validSummary {

    flex: 1;

  }

}

</style>